import { Dispatch } from 'redux';

import * as Actions from '../actions/messageDetail';
import ReplaceStyleKeywords from '../utils/ReplaceStyleKeywords';
import AbstractScenario from './AbstractScenario';

/** メッセージリスト削除シナリオ用パラメータ */
export interface IDeleteMessagesParam {
	messageID: string;
	organizationID: string;
}

/**
 * メッセージ一覧シナリオファクトリ
 */
export default class MessageDetailScenarioFactory {
	/**
	 * 宛て名取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchOnesName(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process(arg: {}) {
				return this.read('per_notice_SubNoticeListTopBlockModel').then(
					data => {
						const onesName: string = data;
						this.dispatch(Actions.setOnesName({ onesName }));
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * メッセージ一覧取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchMessages(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process(arg: {}) {
				return this.read('per_notice_MessageListBlockModel', {
					kind: 0,
				}).then(data => {
					const messages = data.msgList.map((m: any) =>
						MessageDetailScenarioFactory.toMessage(m)
					);
					this.dispatch(Actions.setMessageList({ messages }));
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * メッセージリスト削除シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createDeleteMessages(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IDeleteMessagesParam
		> {
			protected process(arg: IDeleteMessagesParam) {
				const param = {
					kind: 2,
					messageID: arg.messageID,
					organizationID: arg.organizationID,
				};
				return this.read(
					'per_notice_MessageListBlockModel',
					param
				).then(data => {
					const s = MessageDetailScenarioFactory.createFetchMessages(
						dispatch,
						token
					);
					s.run({});
				});
			}
		}(dispatch, token);
		return scenario;
	}

	protected static toMessage = (from: any) => {
		const to: Actions.IMessage = {
			contact: from.contact,
			message: from.message,
			messageID: from.messageID,
			messageList: from.messageList.map((m: string) =>
				ReplaceStyleKeywords.replaceStyleKeywords(m)
			),
			messageType: from.messageType,
			organizationID: from.organizationID,
			startDateStr: from.startDateStr,
			status: from.status,
			title: ReplaceStyleKeywords.replaceStyleKeywords(from.title),
		};
		return to;
	};
}



// WEBPACK FOOTER //
// ./src/scenario/MessageDetailScenarioFactory.ts